(function () {
  'use strict';

  var root = document.querySelector('.gear-2-page') || document;

  root.querySelectorAll('.bb-faq-list').forEach(function (list) {
    list.querySelectorAll('.bb-faq-item').forEach(function (item) {
      var button = item.querySelector('.bb-faq-q');
      if (!button) return;

      button.addEventListener('click', function () {
        var isOpen = item.classList.contains('bb-open');
        list.querySelectorAll('.bb-faq-item.bb-open').forEach(function (openItem) {
          openItem.classList.remove('bb-open');
        });
        if (!isOpen) item.classList.add('bb-open');
      });
    });
  });

  var sticky = root.querySelector('.bb-sticky-bottom');
  var hero = root.querySelector('.bb-hero');
  if (sticky && hero) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('bb-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0.05 }
    );
    observer.observe(hero);
  }
})();
